module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "lists"
  }, [_c('div', {
    staticClass: "list",
    class: {
      new: _vm.New
    }
  }, [_c('div', {
    staticClass: "title",
    class: {
      noTitle: !_vm.Title
    }
  }, [(!_vm.Img) ? _c('div', {
    staticClass: "paper bg-box",
    style: ('background-color: #' + _vm.Color + ';box-shadow: 0px 0px 7px #' + _vm.Color)
  }, [_c('i', [_vm._v(_vm._s(_vm.Name.charAt(0)))])]) : _c('div', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy:background-image",
      value: (_vm.Img),
      expression: "Img",
      arg: "background-image"
    }],
    staticClass: "paper bg-box"
  }), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.Name))])]), _vm._v(" "), _c('h4', [_vm._v(_vm._s(_vm.Title))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f8489522"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/v-list/list.vue
// module id = 157
// module chunks = 1